/**
 * User-facing messages and text constants
 */

// Loading and status messages
export const LOADING_TEXT = "Loading...";
export const GENERIC_ERROR_TEXT = "Oops, something went wrong.";

// Search results messages
export const NO_RESULTS_FOUND_HEADING = "No results found";
export const NO_RESULTS_FOUND_DESCRIPTION =
  "One or more fields contain invalid input.";
export const NO_RESULTS_FOUND_DESCRIPTION_TWO =
  "Please try adjusting your search.";

// Maintenance messages
export const MAINTENANCE_PAGE_TITLE = "The system is down at the moment.";
export const MAINTENANCE_PAGE_DESCRIPTION =
  "The Supply Chain Risk Management Portal is currently down for maintenance and will return shortly.";
export const MAINTENANCE_PAGE_DESCRIPTION_TWO =
  "We are working to resolve the issue as soon as possible. Please try again later.";
